module.exports = __webpack_public_path__ + "img/2023big1.3cd11859.png";